import { ASSET_FAMILY, isFamily, isFamilyToken } from '@exodus/assets';
import { getTxOppositeWalletAccount } from './tx-opposite-wallet-account.js';
const ORDER_ASSET_AWAITING_INBOUND_TX_ID_SEP = '\u0000';
export const makeOrderAssetAwaitingInboundTxIdKey = (walletAccount, assetName) => `${walletAccount}${ORDER_ASSET_AWAITING_INBOUND_TX_ID_SEP}${assetName}`;
const EMPTY_ORDER_ASSET_KEYS = new Set();
const isEvmAsset = (asset) => isFamily({ asset, family: ASSET_FAMILY.EVM });
const isEvmToken = (asset) => isFamilyToken({ asset, family: ASSET_FAMILY.EVM });
const matchesTxIndex = (index, txId, asset, walletAccount) => {
    if (!txId)
        return false;
    const bindings = index.get(txId);
    if (!bindings)
        return false;
    for (const binding of bindings) {
        if (binding.asset === asset && binding.walletAccount === walletAccount)
            return true;
    }
    return false;
};
const collectPendingTxsForAsset = (txSet) => {
    if (!txSet || txSet.size === 0)
        return [];
    const pending = [];
    for (const tx of txSet) {
        if (!tx.pending || tx.failed || tx.data.replacedBy || !tx.coinAmount)
            continue;
        pending.push(tx);
    }
    return pending;
};
export const calculatePendingEvmReceives = ({ txLogs, orderTxIndex, orderAssetKeysAwaitingInboundTxId = EMPTY_ORDER_ASSET_KEYS, fiatOrderTxIndex, assetsModule, enabledWalletAccounts, multipleWalletAccountsEnabled, onError, }) => {
    const result = Object.create(null);
    for (const walletAccount in txLogs) {
        const assetTxSets = txLogs[walletAccount];
        if (!assetTxSets)
            continue;
        for (const assetName in assetTxSets) {
            try {
                const pendingTxs = collectPendingTxsForAsset(assetTxSets[assetName]);
                if (pendingTxs.length === 0)
                    continue;
                const asset = assetsModule.getAsset(assetName);
                if (!asset)
                    continue;
                if (!isEvmAsset(asset))
                    continue;
                const zero = asset.currency.ZERO;
                const assetIsEvmToken = isEvmToken(asset);
                const orderAssetGuardKey = makeOrderAssetAwaitingInboundTxIdKey(walletAccount, assetName);
                for (const tx of pendingTxs) {
                    if (!tx.received)
                        continue;
                    if (!tx.coinAmount || !tx.coinAmount.gt(zero))
                        continue;
                    if (matchesTxIndex(orderTxIndex, tx.txId, assetName, walletAccount))
                        continue;
                    const matchesFiatOrder = matchesTxIndex(fiatOrderTxIndex, tx.txId, assetName, walletAccount);
                    const matchesInternalTransfer = matchesFiatOrder
                        ? false
                        : getTxOppositeWalletAccount(tx, {
                            enabledWalletAccounts,
                            multipleWalletAccountsEnabled,
                            txLogs,
                        }) !== null;
                    const isExpected = matchesFiatOrder || matchesInternalTransfer;
                    if (!isExpected && orderAssetKeysAwaitingInboundTxId.has(orderAssetGuardKey))
                        continue;
                    if (!isExpected && assetIsEvmToken)
                        continue;
                    const walletResult = result[walletAccount] || (result[walletAccount] = Object.create(null));
                    const current = walletResult[assetName] ?? zero;
                    walletResult[assetName] = current.add(tx.coinAmount);
                }
            }
            catch (error) {
                onError?.({ walletAccount, assetName, error });
            }
        }
    }
    return result;
};
